import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { CreateFarmUserDrawerStyle } from './styleDrawer';
import { Button, Drawer, Steps } from 'ui';
import { message } from 'antd';
import { UserProfileInfo } from './Steps/UserProfileInfo';
import { FarmInfo } from './Steps/FarmInfo';
import { FarmReview } from './Steps/FarmReview';
import { ProfileInfo } from './interface';
import useQueryApiClient from '../../../../utils/useQueryApiClient';

interface CreateFarmUserDrawerProps {
  isOpen: boolean | undefined;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  reload: number;
  setReload: React.Dispatch<React.SetStateAction<number>>;
}

export const CreateFarmUserDrawer = ({
  isOpen,
  setIsOpen,
  reload,
  setReload,
}: CreateFarmUserDrawerProps) => {
  const intl = useIntl();

  const [step, setStep] = useState<number>(0);
  const [profileInfo, setProfileInfo] = useState<ProfileInfo>({});

  const [form] = CreateFarmUserDrawerStyle.useForm();

  const BackButton = () => (
    <Button
      className={'back-button'}
      label={intl.formatMessage({ id: 'general.back' })}
      size={'large'}
      onClick={() => {
        setStep(step - 1);
      }}
      htmlType={'submit'}
    />
  );

  const { appendData: storeUser, isLoading } = useQueryApiClient({
    request: {
      url: `api/v2/users/farms`,
      method: 'POST',
      multipart: true,
    },
    onSuccess: () =>
      message.success(intl.formatMessage({ id: 'form.succesfuly_updated' })),
    onError: () => message.success(intl.formatMessage({ id: 'form.error' })),
  });

  const SumbitButton = () => (
    <Button
      className={'submit-button'}
      label={
        step !== 2
          ? intl.formatMessage({ id: 'navigation.continue' })
          : intl.formatMessage({ id: 'navigation.submit' })
      }
      size={'large'}
      onClick={async () => {
        try {
          await form.validateFields();

          setStep(step + 1);
          setProfileInfo({
            ...profileInfo,
            ...form.getFieldsValue(),
            type: 'image',
          });
          if (step === 2) {
            storeUser(profileInfo);
            setIsOpen(false);
            setProfileInfo({});
            setStep(0);
            setReload(reload + 1);
            form.resetFields();
          }
        } catch (error) {
          console.error('Form validation failed:', error);
          return;
        }
      }}
      htmlType={'submit'}
    />
  );

  return (
    <Drawer
      open={isOpen}
      onClose={() => {
        setProfileInfo({});
        setIsOpen(false);
        form.resetFields();
        setStep(0);
      }}
      destroyOnClose
      styled
    >
      <Steps
        current={step}
        items={[
          {
            title: intl.formatMessage({ id: 'general.profile' }),
            description: intl.formatMessage({
              id: 'general.profile_information',
            }),
          },
          {
            title: intl.formatMessage({ id: 'navigation.company' }),
            description: intl.formatMessage({ id: 'navigation.company_info' }),
          },
          {
            title: intl.formatMessage({ id: 'navigation.confirm' }),
            description: intl.formatMessage({
              id: 'navigation.review_and_submit',
            }),
          },
        ]}
      ></Steps>
      <CreateFarmUserDrawerStyle form={form}>
        {step === 0 && <UserProfileInfo form={form} />}
        {step === 1 && <FarmInfo form={form} />}
        {step === 2 && <FarmReview profileInfo={profileInfo} />}
        <div className="button-container">
          {step > 0 && <BackButton />}
          <SumbitButton />
        </div>
      </CreateFarmUserDrawerStyle>
    </Drawer>
  );
};
